import CrudReducer from './crudReducer';

const cr = new CrudReducer('insurer');

const reducer = cr.Reducer;

export default reducer;
